import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
@Pipe({
  name: 'saveHtml'
})
export class SaveHtmlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}
  transform(value: string, args: string = 'image'): any {
    if (args === 'image') return this.sanitizer.bypassSecurityTrustResourceUrl(value);
    else if (args === 'video') return this.sanitizer.bypassSecurityTrustUrl(value);
  }
}
